import { OrganType } from '@/api/apis/case';
import { Hub } from '@/api/apis/facilities';
import { AssignActionType, CSAssignmentCandidate, EmployeeAssignmentCandidateMatch } from '@/api/apis/resources';
import { Uuid } from '@/api/types';

export const getHubNameByHubId = (hubId: Uuid, hubs?: Hub[]): string => hubs?.find((h) => h.id === hubId)?.name ?? '';

export const searchCandidates = <T extends { employeeFullName: string | null }>(
  searchTerm: string,
  candidates?: T[],
): T[] => {
  if (!candidates) return [];
  return candidates.filter((s) => s.employeeFullName?.toLowerCase().includes(searchTerm.toLowerCase()));
};

export const getRadioDisabled = (match: EmployeeAssignmentCandidateMatch) =>
  match.availableActionType === AssignActionType.Detach || match.availableActionType === AssignActionType.LockedAssign;

export const filterTrialProgramSpecialists = (
  specialists: CSAssignmentCandidate[],
  caseOrgan: OrganType,
  trialProgramId?: Uuid,
) => {
  if (!trialProgramId) return specialists;

  return specialists.filter((specialist) =>
    specialist.employeeTrialCertificates?.some((organCert) => organCert === caseOrgan),
  );
};
